import React from 'react';

import { CouldNotGetCardDetailsErrorCard } from '@/components/error/ErrorCard';
import LoaderWithText from '@/components/loading/LoaderWithText';
import { useCreditCardAccount } from '@/domain/account';
import { useCreditCardDetails } from '@/domain/card';
import { V4DigitalWallet } from '@/domain/digital-wallet';
import useText from '@/hooks/use-text';

import { KbDetailsPanelItems } from '@pages/card-details/components/KbCardDetails/DetailsPanelItems/KbDetailsPanelItems';

import { CardDetailsPanel } from './CardDetailsPanel';
import { DesktopCardDetails } from './DesktopCardDetails';

export const KbCardDetails = () => {
    const cardQuery = useCreditCardDetails();
    const accountQuery = useCreditCardAccount();
    const text = useText();

    if (cardQuery.isError || accountQuery.isError) {
        return (
            <>
                <CouldNotGetCardDetailsErrorCard
                    tryAgainClick={() => {
                        if (cardQuery.isError) {
                            cardQuery.refetch();
                        }
                        if (accountQuery.isError) {
                            accountQuery.refetch();
                        }
                    }}
                    errorMessageText={text.cardInformationFetchErrorMessage}
                />
            </>
        );
    }

    if (cardQuery.isLoading || accountQuery.isLoading) {
        return <LoaderWithText title="Laster kort..." />;
    }

    if (cardQuery.isPending || accountQuery.isPending) {
        return null;
    }

    return (
        <div className="sgw-layout seven-four-container">
            <div className="sgw-layout-item seven">
                <div className="sgw-layout-item">
                    <CardDetailsPanel card={cardQuery.data} account={accountQuery.data} />
                </div>
                {cardQuery.data.status === 'NORMAL' && (
                    <div className="sgw-layout-item">
                        <V4DigitalWallet card={cardQuery.data} />
                    </div>
                )}
                <div className="sgw-layout-item">
                    <KbDetailsPanelItems card={cardQuery.data} account={accountQuery.data} />
                </div>

                <div className="sgw-layout-item only-for-desktop">
                    <DesktopCardDetails card={cardQuery.data} account={accountQuery.data} />
                </div>
            </div>
        </div>
    );
};
